import { types } from '../types/types';

export const flowListFilterSetAssignedOnly = (assignedOnly) => ({
  type: types.FLOW_LIST_FILTER_SET_ASSIGNED_ONLY,
  payload: assignedOnly
});

export const flowListFilterSetShowPending = (showPending) => ({
  type: types.FLOW_LIST_FILTER_SET_SHOW_PENDING,
  payload: showPending
});

export const flowListFilterSetShowRejected = (showRejected) => ({
  type: types.FLOW_LIST_FILTER_SET_SHOW_REJECTED,
  payload: showRejected
});

export const flowListFilterSetExtra = (extra = {}) => ({
  type: types.FLOW_LIST_FILTER_SET_EXTRA,
  payload: extra
});

export const flowListFilterSetTrayView = (trayView) => ({
  type: types.FLOW_LIST_FILTER_SET_TRAY_VIEW,
  payload: trayView
});
